// Copyright (c) 2016 Deere & Company

import './pip-history-item-details.scss';
import React, {PropTypes} from 'react';
import LabeledString from '../../../shared/components/labeled-string';
import PipHistory from '@deere/cps-it.warranty-model-factory/lib/pip-history';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDate} from '../../../shared/services/build-date';

const PipHistoryItemDetails = (props, context) =>
    <section className='pip-history-item-details'>
        <LabeledString
            className='pip-history-item-id'
            data={props.pip.pipNumber}
            label='PIP_ID'
        />
        <LabeledString
            className='pip-history-item-type'
            data={props.pip.type.value}
            label='TYPE'
        />
        <LabeledString
            className='pip-history-item-participant'
            data={props.pip.participant.value}
            label='PARTICIPANT'
        />
        <LabeledString
            className='pip-history-item-expiry-date'
            data={buildDate(props.pip.expireDate, context.user.settings.general.dateFormat.key)}
            label='EXPIRES'
        />
    </section>;

PipHistoryItemDetails.displayName = 'PipHistoryItemDetails';
PipHistoryItemDetails.propTypes = {
    pip: PropTypes.instanceOf(PipHistory).isRequired
};
PipHistoryItemDetails.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default PipHistoryItemDetails;




// WEBPACK FOOTER //
// ./src/product/details/components/pip-history-item-details.js